var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-linkedin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.953 1.4375H3.15711C2.23936 1.4375 1.4375 2.09785 1.4375 3.00482V19.8379C1.4375 20.7499 2.23936 21.5625 3.15711 21.5625H19.948C20.8707 21.5625 21.5625 20.7445 21.5625 19.8379V3.00482C21.5679 2.09785 20.8707 1.4375 19.953 1.4375ZM7.6758 18.2127H4.79272V9.24852H7.6758V18.2127ZM6.33398 7.88559H6.31332C5.39062 7.88559 4.79316 7.19873 4.79316 6.33893C4.79316 5.4634 5.40635 4.79271 6.34971 4.79271C7.29307 4.79271 7.87031 5.45846 7.89098 6.33893C7.89053 7.19873 7.29307 7.88559 6.33398 7.88559ZM18.2127 18.2127H15.3296V13.3113C15.3296 12.137 14.91 11.3347 13.8669 11.3347C13.07 11.3347 12.5983 11.8738 12.3886 12.3989C12.3099 12.5876 12.2888 12.8445 12.2888 13.1069V18.2127H9.40574V9.24852H12.2888V10.496C12.7084 9.89853 13.3638 9.03873 14.8889 9.03873C16.7815 9.03873 18.2131 10.2862 18.2131 12.9757L18.2127 18.2127Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoLinkedin);
export default __webpack_public_path__ + "static/media/logo-linkedin.a038645a44ec01384ebca04925599c8d.svg";
export { ForwardRef as ReactComponent };